module.exports = __webpack_public_path__ + "static/media/roboto-bold-webfont.06bc6260.ttf";